module.exports = __webpack_public_path__ + "img/icon-checkmark.58fa48a6ac515f3d3db6787cecb62190.svg";